export default __webpack_public_path__ + "static/media/pattern.cd8f4554.svg";